<template>
<section class="kontakt-firmowy">
  <h2>{{ translations.contact1.title }}</h2>

  <div class="kontakt-blok">
    <p><span class="label">{{ translations.contact1.phone }}</span> +48 720 992 745</p>
    <p><span class="label">{{ translations.contact1.email }}</span> <a href="mailto:biuro@birdstool.pl">biuro@birdea.pl</a></p>
    <p><span class="label">{{ translations.contact1.company }}</span> BIRDSOFT sp. z o.o.</p>
    <p><span class="label">{{ translations.contact1.nip }}</span> PL6222856070</p>
    <p><span class="label">{{ translations.contact1.address }}</span> ul. Kaliska 35A/210</p>
    <p><span class="label">{{ translations.contact1.city }}</span> Ostrów Wielkopolski</p>
    <p><span class="label">{{ translations.contact1.country }}</span> Polska</p>
  </div>
</section>
</template>

<script>
import { translations } from '@/locales/lang'

export default {
  name: 'AppKontakt',
  computed: {
    translations() {
      return translations.value
    },
  },
}
</script>
